module.exports = __webpack_public_path__ + "static/media/slide4.c77fbd06.jpg";